import { _t } from 'app/utils/i18n';
import { path } from 'app/utils/path';
import React from 'react';
import { apiRoutes } from 'videos/utils/apiRoutes';
import SecondaryTable from 'app/components/Tables/SecondaryTable';
import DashboardHashtagsMap from 'app/components/TextMap';
import IconCard from 'app/components/IconCard';
import {
  ClockIcon,
  EyeIcon,
  LangIcon,
  LanguageIcon,
  LatestUpdateIcon,
  LikeIcon,
  MessageIcon,
  PlusIcon,
  Resume,
  TotalInf,
  UploadIcon,
} from 'app/assets/images/icons';
import DonutChart from 'app/components/Charts/DonutChart';
import NumberOfPosts from 'app/components/Tables/Cells/NumberOfPosts';
import ItemPopperCell from 'app/components/Tables/Cells/ItemPoperCell';
import { Link } from 'react-router-dom';
import { nFormatter } from 'app/utils/numbersFormater';
import MostFrequentCard from 'app/components/MostFrequentCard';
import AvatarCell from 'app/components/Tables/Cells/AvatarCell';

import { renderPlatformIcon } from 'app/utils/renderPlatformIcon';
import ToolTipComp from 'app/components/ToolTipComp';
import { getFromLocalStorage } from 'app/utils/localStorage';
import ErrorBoundary from 'app/components/ErrorBoundary';
import {
  getHighestCountry,
  getLowestCountry,
} from 'app/utils/getLowestCountry';
import { checkHoveringTranslated, checkTranslated } from 'app/utils/helpers';
import { TColumns } from 'app/components/MainTableMultiTabs/types';
import { dateTimeFormatter } from 'app/utils/dateTimeFormatter';
import { checkRouteName } from 'app/utils/check-route-name';
import { ModalContextType } from 'app/context/Modal';

const isEn = getFromLocalStorage('LNG') == 'en' ? true : false;

const LOCAL_STORAGE_KEY = 'VIDEOS_COMPONENT_DASHBOARD';
export const videoIconCards = [
  {
    title: _t('trends:vid_view'),
    icon: <EyeIcon />,
    key: 'views_count',
    id: 'video_views',
  },
  {
    title: _t('trends:vid_likes'),
    icon: <LikeIcon />,
    key: 'likes_count',
    id: 'video_likes',
  },
  // {
  //   title: _t('trends:vid_dislikes'),
  //   icon: <DisLikeIcon />,
  //   key: 'dislikes_count',
  //   id: 'videoDislikes',
  // },
  {
    title: _t('trends:vid_comments'),
    icon: <MessageIcon />,
    key: 'comments_count',
    id: 'video_comments',
  },
  {
    title: _t('videos:published_date'),
    icon: <ClockIcon />,
    key: 'published_at',
    id: 'published_date',
  },
  {
    title: _t('videos:latest_update'),
    icon: <LatestUpdateIcon />,
    key: 'grabbed_at',
    id: 'latest_update',
  },
];

export const channelIconCard = [
  {
    title: _t('videos:total_num_view'),
    icon: <EyeIcon />,
    key: 'views_count',
    id: 'total_num_of_views',
  },
  {
    title: _t('trends:uploaded_video'),
    icon: <UploadIcon />,
    key: 'uploaded_count',
    id: 'uploaded_videos',
  },
  {
    title: _t('trends:channel_sub'),
    icon: <PlusIcon />,
    key: 'subscriber_count',
    id: 'subscriber_count',
  },
];

export const baseLineData = (): any => [
  {
    title: _t('trends:gained_subs'),
    slugName: apiRoutes().channelSubscribers,
    id: 'gained_subscribers',
  },

  /*{
    title: _t('trends:channel_eng'),
    slugName: apiRoutes().videosEngagement,
    id: 'influenderEngeg',
  },*/
  {
    title: _t('trends:channel_views'),
    slugName: apiRoutes().channelViews,
    id: 'channel_views',
  },
];
export const trendingListColumns: TColumns[] = [
  {
    title: _t('videos:video_title'),
    key: 'title',
    render: (val: any, row: any) => (
      <p
        className="truncate-text"
        title={checkTranslated(row.title, row.title_translated)}
        style={{ width: '90%' }}
      >
        {checkTranslated(row.title, row.title_translated)}
      </p>
    ),
  },
  {
    title: _t('hashtags:trending_on'),
    key: 'created_at',
    render: (value: string) =>
      dateTimeFormatter.date(value, undefined, true) as any,
  },
  {
    title: 'country',
    key: 'countries',
    render: (data: any) => (
      <ItemPopperCell
        data={data?.slice(0, 5)?.map((item: any) => ({
          ...item,
          title: item.country_name,
          count: item.mentions,
        }))}
        headers={[_t('basic:countries'), _t('basic:rank')]}
        text={getHighestCountry(data)?.name || ''}
      />
    ),
  },
  {
    title: 'basic:translation',
    key: 'translation',
    render: (val: any, row: any) => (
      <>
        {row?.title_translated?.length > 0 ? (
          <ToolTipComp
            title={checkHoveringTranslated(row.title, row.title_translated)}
          >
            <LangIcon />
          </ToolTipComp>
        ) : (
          <p> - </p>
        )}
      </>
    ),
  },
];
export const channelTopVideosColumn: TColumns[] = [
  {
    title: 'trends:videos',
    key: 'videos',
    render: (val: any, row: any) => (
      <>
        <Link
          to={`${path.videos.VIDEO_VIEW_URI}/${row.video_id}`}
          title={
            row.title_translated?.length
              ? isEn
                ? row.title
                : row.title_translated
              : row.title
          }
        >
          {row.title_translated?.length > 0 ? (
            <span> {isEn ? row.title : row.title_translated}</span>
          ) : (
            row.title
          )}
        </Link>
      </>
    ),
  },
  {
    title: 'trends:views',
    key: 'views_count',
    render: (data: any) => nFormatter(data) as any,
  },
  {
    title: 'basic:translation',
    key: 'title',
    render: (val: any, row: any) => (
      <>
        {row.title_translated?.length > 0 ? (
          <ToolTipComp title={isEn ? row.title_translated : row.title}>
            <LanguageIcon />
          </ToolTipComp>
        ) : (
          <p> -</p>
        )}
      </>
    ),
  },
];

export const relatedInfluencersColumns: TColumns[] = [
  {
    title: _t('videos:name'),
    key: 'name',
    render: (val: any, row: any) => (
      <Link
        to={`${path.influencers.ANALYZED_INFLUENCER_DETAILS_URI}/${row.id}`}
      >
        {checkTranslated(row?.name?.original, row?.name?.arabic)}
      </Link>
    ),
  },
  {
    title: _t('videos:followers'),
    key: 'followers_count',
    render: (item: any) => nFormatter(item) as any,
  },
];
export const relatedEntitiesColumns: TColumns[] = [
  {
    title: _t('videos:name'),
    key: 'name',
    render: (val: any, row: any) => (
      <Link to={`${path.entities.ANALYZED_ENTITIES_DETAILS_URI}/${row.id}`}>
        {checkTranslated(row.name.original, row.name.arabic)}
      </Link>
    ),
  },
  {
    title: _t('videos:followers'),
    key: 'followers_count',
    render: (item: any) => nFormatter(item) as any,
  },
];
const videosComponents = (
  modules: string[],
  modal: ModalContextType,
  openModalToAddinfluencer: (
    remote_id: string,
    url: string,
    youtube?: boolean
  ) => void,
  setInfluencerName: (value: any) => void
): any => {
  const trendingVideosColumns = [
    {
      title: _t('videos:video'),
      key: 'title',
      render: (val: any, row: any) => (
        <>
          <Link
            to={`${path.videos.VIDEO_VIEW_URI}/${row.id}`}
            title={
              row.title_translated.length
                ? isEn
                  ? row.title
                  : row.title_translated
                : row.title
            }
          >
            {row.title_translated.length > 0 ? (
              <span> {isEn ? row.title : row.title_translated}</span>
            ) : (
              row.title
            )}
          </Link>
        </>
      ),
    },
    {
      title: 'videos:platform',
      key: 'platforms',
      render: (value: any) => <NumberOfPosts data={value} hideText />,
    },
    {
      title: 'country',
      key: 'countries',
      render: (value: any) => (
        <ItemPopperCell
          data={value.slice(0, 5)}
          headers={[_t('basic:country'), _t('basic:rank')]}
          itemKey=""
          text={getLowestCountry(value)?.name || ''}
          countryRank
        />
      ),
    },
    {
      title: 'basic:translation',
      key: 'title',
      render: (val: any, row: any) => (
        <>
          {row.title_translated.length > 0 ? (
            <ToolTipComp title={isEn ? row.title_translated : row.title}>
              <LanguageIcon />
            </ToolTipComp>
          ) : (
            <p> - </p>
          )}
        </>
      ),
    },
  ];

  const mostViewedVideosColumns = [
    {
      title: 'videos:video',
      key: 'title',
      render: (val: any, row: any) => (
        <>
          <Link
            to={`${path.videos.VIDEO_VIEW_URI}/${row.id}`}
            title={
              row.title_translated.length
                ? isEn
                  ? row.title
                  : row.title_translated
                : row.title
            }
          >
            {row.title_translated.length > 0 ? (
              <AvatarCell
                icon={renderPlatformIcon(row.platforms[0].name)}
                text={isEn ? row.title : row.title_translated}
                moduleName="videos"
                hideImg
              />
            ) : (
              <AvatarCell
                icon={renderPlatformIcon(row.platforms[0].name)}
                text={row.title}
                moduleName="videos"
                hideImg
              />
            )}
          </Link>
        </>
      ),
    },
    {
      title: 'videos:num_of_views',
      key: 'views_count',
      render: (value: any) => nFormatter(value),
    },
    {
      title: 'basic:translation',
      key: 'title',
      render: (val: any, row: any) => (
        <>
          {row.title_translated.length > 0 ? (
            <ToolTipComp title={isEn ? row.title_translated : row.title}>
              <LanguageIcon />
            </ToolTipComp>
          ) : (
            <p> -</p>
          )}
        </>
      ),
    },
  ];
  const recentVideosColumns = [
    {
      title: _t('videos:video'),
      key: 'title',
      render: (val: any, row: any) => (
        <>
          <Link
            to={`${path.videos.VIDEO_VIEW_URI}/${row.id}`}
            title={
              row.title_translated.length
                ? isEn
                  ? row.title
                  : row.title_translated
                : row.title
            }
          >
            {row.title_translated.length > 0 ? (
              <span> {isEn ? row.title : row.title_translated}</span>
            ) : (
              row.title
            )}
          </Link>
        </>
      ),
    },
    {
      title: 'videos:entity',
      key: 'channel_name',
      render: (val: any, row: any) => (
        <>
          {(modules.includes('ENTITIES') && row?.influencer?.is_entity) ||
          (modules.includes('INFLUENCERS') && !row?.influencer?.is_entity) ? (
            row?.influencer?.id ? (
              <Link
                to={`${
                  row?.influencer?.is_entity
                    ? path.entities.ANALYZED_ENTITIES_DETAILS_URI
                    : row?.influencer?.is_influencer
                    ? path.influencers.ANALYZED_INFLUENCER_DETAILS_URI
                    : path.influencers.UN_ANALYZED_INFLUENCER_DETAILS_URI
                }/${row?.influencer?.id}`}
                title={row?.channel_name}
              >
                {row?.channel_name}
              </Link>
            ) : (
              <a
                onClick={() => {
                  openModalToAddinfluencer(
                    row?.channel?.remote_id,
                    row?.url,
                    true
                  );
                  setInfluencerName(row?.channel_name);
                }}
                className="cursor-pointer"
              >
                {row?.channel_name}
              </a>
            )
          ) : (
            <a
              className="cursor-pointer"
              onClick={() =>
                modal.show({
                  isAlternative: true,
                  message: _t(`basic:you_are_not_authorize`),
                })
              }
            >
              {row?.channel_name}
            </a>
          )}
        </>
      ),
    },
    {
      title: 'basic:translation',
      key: 'title',
      render: (val: any, row: any) => (
        <>
          {row.title_translated.length > 0 ? (
            <ToolTipComp title={isEn ? row.title_translated : row.title}>
              <LanguageIcon />
            </ToolTipComp>
          ) : (
            <p> -</p>
          )}
        </>
      ),
    },
  ];
  const components = [
    {
      component: (
        <ErrorBoundary>
          <IconCard
            title={_t('videos:total_videos')}
            cardData={{
              icon: <Resume />,
            }}
            slug={apiRoutes().totalVideosCount}
            increaseHeight
            withFilter
            compId="videos_dashboard_total_videos"
          />
        </ErrorBoundary>
      ),
      id: 1,
      grid: {
        sm: 6,
        lg: 3,
        xl: 2,
      },
      show: true,
    },
    {
      component: (
        <ErrorBoundary>
          <IconCard
            title={_t('videos:total_entities')}
            cardData={{
              icon: <TotalInf />,
            }}
            slug={apiRoutes().totalEntitiesCount}
            increaseHeight
            withFilter
            compId="videos_dashboard_total_entities"
          />
        </ErrorBoundary>
      ),
      id: 2,
      grid: {
        sm: 6,
        lg: 3,
        xl: 2,
      },
      show: true,
    },
    {
      component: (
        <ErrorBoundary>
          <DonutChart
            donutTitle={_t('videos:video_platform')}
            compId="videos_dashboard_video_platform"
            slug={apiRoutes().videoPlatform}
            title={_t('basic:videos')}
            limit={4}
            showFilter
          />
        </ErrorBoundary>
      ),
      id: 3,
      grid: {
        sm: 12,
        md: 6,
        xl: 3,
      },
      show: true,
    },
    {
      component: (
        <ErrorBoundary>
          <SecondaryTable
            tableCardTitle={_t('videos:trending_videos')}
            columns={trendingVideosColumns}
            moduleName={apiRoutes().videosDashboardTrendVideos}
            compId="videos_dashboard_trending_vidoes"
            customFilters={{ limit: 5 }}
            expandUrlWithNavigate
            expandUrl={{
              pathname: path.videos.VIDEOS_TABLE,
              state: { activeTab: 'trending' },
            }}
            firstTitle="platforms"
            secondTitle="views"
          />
        </ErrorBoundary>
      ),
      id: 4,
      grid: {
        md: 6,
        xl: 5,
        sm: 12,
      },
      show: true,
    },
    {
      component: (
        <ErrorBoundary>
          <SecondaryTable
            tableCardTitle={_t('videos:most_viewed_videos')}
            columns={mostViewedVideosColumns as any}
            moduleName={apiRoutes().mostViewedVideos}
            compId="videos_dashboard_most_viewed_videos"
            hideToggleView
            hideCountry
            hidePlatform
            hideIfNoData={!checkRouteName('dashboard')}
          />
        </ErrorBoundary>
      ),
      id: 5,
      grid: {
        md: 6,
        xl: 4,
        sm: 12,
      },
      show: true,
    },
    {
      component: (
        <ErrorBoundary>
          <SecondaryTable
            tableCardTitle={_t('videos:recent_videos')}
            columns={recentVideosColumns}
            moduleName={apiRoutes().mostRecentVideos}
            compId="videos_dashboard_recent_videos"
            hideToggleView
            hidePlatform
            customFilters={{ limit: 10 }}
            allCountriesFilter
          />
        </ErrorBoundary>
      ),
      id: 6,
      grid: {
        md: 6,
        xl: 4,
        sm: 12,
      },
      show: true,
    },
    {
      component: (
        <ErrorBoundary>
          <MostFrequentCard
            title={_t('videos:top_used_hashtags')}
            expandLink={`${path.hashtags.HASHTAG_VIEW_URI}`}
            slug={apiRoutes().topUsedHashtags}
            moduleName={'HASHTAGS'}
            compId="videos_dashboard_most_frequent_words"
          />
        </ErrorBoundary>
      ),
      id: 7,
      grid: {
        xs: 12,
        md: 6,
        xl: 4,
      },
      show: true,
    },
    {
      component: (
        <ErrorBoundary>
          <DashboardHashtagsMap
            expandUrl={path.videos.TOP_COUNTRIES_WORLD_MAP}
            api={apiRoutes().dashboardVideosMap}
            mapTitle={_t('trends:trending_map')}
            showFilters
            currentModule="videos"
            compId="videos_dashboard_trending_map"
          />
        </ErrorBoundary>
      ),
      id: 8,
      grid: {
        xs: 12,
      },
      show: true,
    },
  ];
  return components;
};

export { videosComponents, LOCAL_STORAGE_KEY };
